import Price from '~/utils/Price/Price';

export const calculatePrice = (price: Price, packageSize: number, referencePackagePrice: number): Price => {
	const value = (Number(price.value) / packageSize) * referencePackagePrice;
	return new Price(String(value), price.currency);
};
